import { twMerge } from "tailwind-merge"

type DividerProps = {
    axis: "x" | "y"
    className?: string
}

const Divider = (props: DividerProps) => {

    return (
        <div className={twMerge(
            "bg-secondary-100 rounded-md",
            props.axis == "x" ? "flex-1 h-px" : "w-px h-6",
            props.className
        )}
        ></div>
    )
}

export default Divider